export default "/images/android-chrome-192x192.png?658a1544b40d41ae4b55d126ccba04fe";